<template>
    <div id="wrapper" class="wrapper row3">
      <div class="browser-screen-loading-content" v-if="!loading && client === ''">
        <div class="loading-dots dark-gray">
          <i></i>
          <i></i>
          <i></i>
          <i></i>
        </div>
      </div>
      <img id="logo_client" v-if="!ip_error && client !== ''" style="padding: 50px 0;max-height: 180px;" :class="'hoc ' +client + '_logo'" onerror="this.src='./static/images/demo.png'" :src="'./static/images/'+client+'.png'">
      <b-tabs v-if="config.datable_list" class="hoc">
        <div class="logout">
          <v-btn x-large color="#2FA284" v-if="allowLogout" class="btn-logout" @click="logout()" >Se déconnecter</v-btn>
        </div>

        <b-tab title="Liste des boîtiers" active v-if="tabs_list.status" >
              <tab-content v-if="config.datable_list" :headers="config.datable_list.headers"
                              :sorting="config.datable_list.sorting" :defaultType="config.default_list_rmbox_type" :filterList="config.filter_list" :date_update_data="date_update_data" :date_next_update_data="date_next_update_data"
                              api="api_dtable_list_dtable_rmboxs_list_status" id="status14"></tab-content>
          </b-tab>
          <b-tab title="Interventions des boîtiers" v-on:click="enableIntervention" v-if="tabs_list.intervention">
              <tab-content v-if="config.datable_list && interActive" :headers="headers_intervention"
                             :sorting="sortingInt" :filterList="[{byType: false}, {byWord: true}, {byStatus: false}]"
                             api="api_dtable_list_dtable_intervention_rmboxs_list" id="intervention"></tab-content>
          </b-tab>
          <b-tab title="Ips inconnus" v-on:click="enableUnknownIp" v-if="tabs_list.ip">
              <tab-content v-if="config.datable_list && ipActive" :headers="headers_unknown_ip"
                             :sorting="sortingIp" :filterList="[{byType: false}, {byWord: true}, {byStatus: false}]" :date_update_data="date_update_data" :date_next_update_data="date_next_update_data"
                             api="api_dtable_list_dtable_unknown_ip_list" id="ip"></tab-content>
          </b-tab>
          <b-tab title="Incidents" v-on:click="enableIncident" v-if="tabs_list.incident">
              <tab-content v-if="config.datable_list && incidentActive" :headers="headers_incident"
                           :sorting="sortingIncident" :filterList="[{byType: false}, {byWord: true}, {byStatus: false}]"
                           api="api_dtable_get_player_incidents" id="incident"></tab-content>
          </b-tab>
      </b-tabs>
      <div class="error_block" v-if="ip_error">
      <img  src="../assets/404.jpg">
        <h1>Ouups! Erreur</h1>
      <h2 class="error_message">Désolé mais la page que vous recherchez ne peut être trouvée.</h2>
      </div>
    </div >

</template>

<script>
  import {HTTP} from '../core/http/http-common';
  import Routing from '../core/router/router';
  import TabContent from "./tabContent.vue";
    export default {
      components: {TabContent},
      name: "status-list",

      data() {
        return {
          config : {},
          sortingInt : {
            rmbox_name : 10,
            rmbox_ip : 9,
            remarque : 1,
            receptionDate : 2,
            sendDate : 3,
            oldMac : 4,
            newMac : 5,
            firstStartedDate : 6,
          },
            sortingIp : {
            ip : 1,
                created_at : 2,
          },
            sortingIncident : {
                codeError : 1,
                options : 2,
                ipClient : 3,
                idVideo : 4,
                rmbox_default_name : 7,
                rmbox_player_name : 10,
                zone_name : 12,
                created_at : 13,
          },
          headers_intervention: [
            {text : 'Boitier', value : 'rmbox_name'},
            {text : 'IP', value : 'rmbox_ip'},
            {text : 'Remarque', value : 'remarque'},
            {text : 'Date reception', value : 'receptionDate'},
            {text : 'Date envoi', value : 'sendDate'},
            {text : 'Ancienne MAC', value : 'oldMac'},
            {text : 'Nouvelle MAC', value : 'newMac'},
            {text : 'Date 1ere mise en marche', value : 'firstStartedDate'}
          ],
            headers_unknown_ip: [
                {text : 'IP', value : 'ip'},
                {text : 'Date', value : 'created_at'},
            ],
            headers_incident: [
                {text : 'IP Client', value : 'ipClient'},
                {text : 'Identifiant vidéo', value : 'idVideo'},
                {text : "Code d'erreur", value : 'codeError'},
                {text : "Message d'erreur", value : 'messageError'},
                {text : 'Remarques', value : 'options'},
                {text : 'Boîtier', value : 'rmbox_player_name'},
                {text : 'Boîtier par défaut', value : 'rmbox_default_name'},
                {text : 'Zone', value : 'zone_name'},
                {text : 'Date', value : 'created_at'},
            ],
          ip_error : false,
            allowLogout : true,
          interActive : false,
            ipActive : false,
            incidentActive : false,

        }
      },
      mounted(){


      },
      methods:{
        logout(){
          this.$cookie.set('user',null)
          this.$router.push({
            name: 'login'})
          this.$session.destroy();
        },

        enableIntervention(){
          this.interActive = true;
        },
          enableUnknownIp(){
          this.ipActive = true;
        },
          enableIncident(){
          this.incidentActive = true;
        }
      },
      created(){
          let self = this;
          this.client = '';
          this.loading = false;
          var query = {is_allowed:self.$cookie.get('user')&& self.$cookie.get('user')!=="null"?1:0};
          HTTP.get(Routing.generate("api_configuration_get_status_client_config",query))
          .then(function(response){
            if(response.data.code === 200){
                if(query.is_allowed===0)
                    self.allowLogout=false;
              self.client = response.data.data.client;
              self.config = response.data.data;

              self.config.datable_list.headers.push({ text: '', value: 'data-table-expand' })

              self.loading = true;
                self.tabs_list = response.data.data.tabs_list;
                if(!self.tabs_list.status){
                    if(self.tabs_list.intervention){
                        self.interActive = true;
                    }else if(self.tabs_list.ip){
                        self.ipActive = true;
                    }else if(self.tabs_list.incident){
                        self.incidentActive = true;
                    }
                }
                self.date_update_data = response.data.data.date_update_data;
                self.date_next_update_data = response.data.data.date_next_update_data;
            }
            else if(response.data.code === 403){
                if(!self.$cookie.get('user') || self.$cookie.get('user')=="null"){
                    self.$router.push({
                        name: 'login'})
                }
            }
          },function(error){
            console.log(error)
          });

                }
    }
</script>

<style lang="scss">
  .logout{
    display: flex;
    justify-content: flex-end;
  }

  .mae_logo{
    max-height: 220px!important;
  }
  .btn-logout{
    border: none;
    color: #ededed!important;
    background: #2FA284;
    text-transform: inherit
  }

  .wrapper{display:block; position:relative; width:100%; height:100%;margin:0; padding:0; text-align:left; word-wrap:break-word;}
  .row3 {
    color: #474747;
    background-color: #fbfbfb;
  }
  .error_message {
    color: #444;
    margin: auto;
    padding: 1em 2em;
  }
  .error {
    background-color: #ff5252 !important;
    border-color: #ff5252 !important;
  }
  .error_block{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 4em;
    h1{
      color: #0079fe;
      margin: auto;
      padding: 1em 0.5em 0em 0.5em;
    }
  }
  .hoc{display:block; margin:0 auto;}
  .container {
    padding: 80px 0;
  }
  .nav-item {
    float: left;
    width: 25%;
  }
  .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
      border: none!important;
      border-bottom: 3px solid #474747!important;
  }
  .nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover{
      border: none!important;

  }
  .nav-tabs .nav-link{
    border: none;
  }

  .nav-item a{
    font-size: 18px;
    line-height: 1.4;
    padding: 6px 12px;
    -webkit-transition: .3s cubic-bezier(.25,.8,.5,1);
    transition: .3s cubic-bezier(.25,.8,.5,1);
    -webkit-user-select: none;
    text-align: center;
    text-transform: uppercase;
    font-weight: 500;
    opacity: .7;
    color: rgb(106, 106, 106);
  }
  .nav-item a:hover {
    color: #0056b3;
    text-decoration: underline;
  }
  .nav-item a.active{
    opacity: 1;
    text-decoration: none;
  }
  @media screen and (min-width: 978px) {
    .hoc {
      max-width: 80%;
    }
  }
  @media screen and (max-width: 1050px) {
    .hoc {
      max-width: 90%;
    }
  }
  @media (max-width: 479px) and (min-width: 0px){/*Zoom 400 et 500*/
      .nav-item {
          width: 100%;
      }
      .v-card__title .v-select, .v-card__title .v-input{
          width: 100%;
      }
    .video_missing .v-toolbar__title{
      font-size: 13px;
    }

  }
  th{
    .v-icon{
      float: right;
    }
  }
  .browser-screen-loading-content {
    text-align: center;
    height: 100%;
    max-width: 100%;
    position: relative;
    top: 0;
    right: 0;
    bottom: 3em;
    left: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loading-dots {
    margin-left: -1.5em;
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
    -webkit-animation: loading-dots-fadein .5s linear forwards;
    -moz-animation: loading-dots-fadein .5s linear forwards;
    -o-animation: loading-dots-fadein .5s linear forwards;
    -ms-animation: loading-dots-fadein .5s linear forwards;
    animation: loading-dots-fadein .5s linear forwards;
  }
  .loading-dots i {
    width: .5em;
    height: .5em;
    display: inline-block;
    vertical-align: middle;
    background: #e0e0e0;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    margin: 0 .125em;
    -webkit-animation: loading-dots-middle-dots .5s linear infinite;
    -moz-animation: loading-dots-middle-dots .5s linear infinite;
    -o-animation: loading-dots-middle-dots .5s linear infinite;
    -ms-animation: loading-dots-middle-dots .5s linear infinite;
    animation: loading-dots-middle-dots .5s linear infinite;
  }
  .loading-dots.dark-gray i {
    background: #707070;
  }
  .loading-dots i:first-child {
    -webkit-animation: loading-dots-first-dot .5s infinite;
    -moz-animation: loading-dots-first-dot .5s linear infinite;
    -o-animation: loading-dots-first-dot .5s linear infinite;
    -ms-animation: loading-dots-first-dot .5s linear infinite;
    animation: loading-dots-first-dot .5s linear infinite;
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
    -webkit-transform: translate(-1em);
    -moz-transform: translate(-1em);
    -o-transform: translate(-1em);
    -ms-transform: translate(-1em);
    transform: translate(-1em);
  }
  .loading-dots i:last-child {
    -webkit-animation: loading-dots-last-dot .5s linear infinite;
    -moz-animation: loading-dots-last-dot .5s linear infinite;
    -o-animation: loading-dots-last-dot .5s linear infinite;
    -ms-animation: loading-dots-last-dot .5s linear infinite;
    animation: loading-dots-last-dot .5s linear infinite;
  }


  @-moz-keyframes loading-dots-fadein{100%{opacity:1;-ms-filter:none;filter:none}}
  @-webkit-keyframes loading-dots-fadein{100%{opacity:1;-ms-filter:none;filter:none}}
  @-o-keyframes loading-dots-fadein{100%{opacity:1;-ms-filter:none;filter:none}}
  @keyframes loading-dots-fadein{100%{opacity:1;-ms-filter:none;filter:none}}

  @-moz-keyframes loading-dots-first-dot{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em);opacity:1;-ms-filter:none;filter:none}}
  @-webkit-keyframes loading-dots-first-dot{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em);opacity:1;-ms-filter:none;filter:none}}
  @-o-keyframes loading-dots-first-dot{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em);opacity:1;-ms-filter:none;filter:none}}
  @keyframes loading-dots-first-dot{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em);opacity:1;-ms-filter:none;filter:none}}


  @-moz-keyframes loading-dots-middle-dots{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em)}}
  @-webkit-keyframes loading-dots-middle-dots{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em)}}
  @-o-keyframes loading-dots-middle-dots{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em)}}
  @keyframes loading-dots-middle-dots{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em)}}


  @-moz-keyframes loading-dots-last-dot{100%{-webkit-transform:translate(2em);-moz-transform:translate(2em);-o-transform:translate(2em);-ms-transform:translate(2em);transform:translate(2em);opacity:0;-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";filter:alpha(opacity=0)}}
  @-webkit-keyframes loading-dots-last-dot{100%{-webkit-transform:translate(2em);-moz-transform:translate(2em);-o-transform:translate(2em);-ms-transform:translate(2em);transform:translate(2em);opacity:0;-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";filter:alpha(opacity=0)}}
  @-o-keyframes loading-dots-last-dot{100%{-webkit-transform:translate(2em);-moz-transform:translate(2em);-o-transform:translate(2em);-ms-transform:translate(2em);transform:translate(2em);opacity:0;-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";filter:alpha(opacity=0)}}
  @keyframes loading-dots-last-dot{100%{-webkit-transform:translate(2em);-moz-transform:translate(2em);-o-transform:translate(2em);-ms-transform:translate(2em);transform:translate(2em);opacity:0;-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";filter:alpha(opacity=0)}}
</style>



// WEBPACK FOOTER //
// src/components/statusList.vue